export default __webpack_public_path__ + "static/media/bubble-whitelist-sale.8c676299.svg";